import { Component, OnInit, Input } from '@angular/core';
import { ExtraFieldCounterService } from 'src/app/services/shared/extraFieldCounter';

@Component({
  selector: 'apc-extra-fields-buttons',
  templateUrl: './extra-fields-buttons.component.html',
  styleUrls: ['../action-buttons.component.scss', './extra-fields-buttons.component.scss'],
})
export class ExtraFieldsButtonsComponent implements OnInit {
  @Input() pertinence: string;
  @Input() section: string;
  @Input() subsection: string;
  @Input() personaSubsectionIdentifier: string;
  @Input() personaIdentifier: string;
  @Input() formId: string;

  public noteButton: Object = '';
  public fileButton: Object = '';
  public customFieldButton: Object = '';
  public linkButton: Object = '';

  public noteCounter = 0;
  public fileCounter = 0;
  public customFieldCounter = 0;
  public linkCounter = 0;

  constructor(private extraFieldCounterService: ExtraFieldCounterService) {
    this.extraFieldCounterService.extrasRefreshed.subscribe((fetch) => this.calculateExtras());
  }

  async ngOnInit() {
    this.noteButton = {
      pertinence: this.pertinence,
      section: this.section,
      subsection: this.subsection.replace('-', ''),
      context: 'note',
      type: 'READER',
    };
    this.fileButton = {
      pertinence: this.pertinence,
      section: this.section,
      subsection: this.subsection.replace('-', ''),
      context: 'file',
      type: 'READER',
    };
    this.customFieldButton = {
      pertinence: this.pertinence,
      section: this.section,
      subsection: this.subsection.replace('-', ''),
      context: 'customfield',
      type: 'READER',
    };
    this.linkButton = {
      pertinence: this.pertinence,
      section: this.section,
      subsection: this.subsection.replace('-', ''),
      context: 'link',
      type: 'READER',
    };
  
    this.calculateExtras();
  }

  calculateExtras() {
    let fileCount = this.extraFieldCounterService.extraCount.find(
      (el) => el.extraType == 'file' && el.subsection === this.subsection && el.subsectionIdentifier === this.formId
    );
    this.fileCounter = fileCount ? fileCount.count : 0;

    let noteCount = this.extraFieldCounterService.extraCount.find(
      (el) => el.extraType == 'note' && el.subsection === this.subsection && el.subsectionIdentifier === this.formId
    );
    this.noteCounter = noteCount ? noteCount.count : 0;

    let customFieldCount = this.extraFieldCounterService.extraCount.find(
      (el) => el.extraType == 'customfield' && el.subsection === this.subsection && el.subsectionIdentifier === this.formId
    );
    this.customFieldCounter = customFieldCount ? customFieldCount.count : 0;

    let linksCount = this.extraFieldCounterService.extraCount.find(
      (el) => el.extraType == 'link' && el.subsection === this.subsection && el.subsectionIdentifier === this.formId
    );
    this.linkCounter = linksCount ? linksCount.count : 0;
  }
}
